import React from 'react';
import { RotateCcw } from 'lucide-react';

/**
 * Pill flotante sobre el input: cada clic inyecta otra pregunta sugerida en el campo.
 */
export default function AssistantSuggestPill({ onClick, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="wa-asistente-suggest-pill"
      aria-label="Sugiéreme una pregunta para el asistente"
    >
      <RotateCcw size={14} strokeWidth={2} aria-hidden className="wa-asistente-suggest-pill-icon" />
      Sugiéreme algo
    </button>
  );
}
